const PRESS_LOGOS = [{
  src: "/assets/images/travel-agent/press-logos/nyt.webp",
  alt: "The New York Times"
}, {
  src: "/assets/images/travel-agent/press-logos/forbes.webp",
  alt: "Forbes"
}, {
  src: "/assets/images/travel-agent/press-logos/usa-today.webp",
  alt: "USA Today"
}, {
  src: "/assets/images/travel-agent/press-logos/travel-leisure.webp",
  alt: "Travel + Leisure"
}, {
  src: "/assets/images/travel-agent/press-logos/bbc.webp",
  alt: "BBC"
}, {
  src: "/assets/images/travel-agent/press-logos/lonely-planet.webp",
  alt: "Lonely Planet"
}];
const BookWithConfidenceSection = () => {
  return <section className='px-[60px] pb-[30px] pt-10 text-center md:px-[100px] md:pb-[60px] md:pt-20' data-sentry-component="BookWithConfidenceSection" data-sentry-source-file="BookWithConfidenceSection.tsx">
      <h2 className='font-wasgaten text-[30px] leading-[1.2] tracking-[-0.015em] text-secondary-500 md:text-[42px]'>
        Book with confidence
      </h2>

      <p className='mx-auto mt-3 max-w-[305px] text-[15px] leading-[1.5] text-brand-dark md:mt-3.5 md:max-w-[1051px] md:text-[25px]'>
        With over 2 million nights sold, a team of travel pros, and a five-year
        record of steady growth,{" "}
        <span className='font-semibold'>you&apos;re in good hands.</span>
      </p>

      <div className='mt-5 grid grid-cols-2 items-center justify-items-center gap-x-6 gap-y-6 md:mt-[30px] md:flex md:flex-nowrap md:justify-between md:gap-x-4'>
        {PRESS_LOGOS.map(logo => <div key={logo.alt} className='flex h-[50px] w-full max-w-[140px] items-center justify-center md:h-[90px] md:max-w-[180px] md:flex-1'>
            <img src={logo.src} alt={logo.alt} className='max-h-full max-w-full object-contain' />
          </div>)}
      </div>
    </section>;
};
export default BookWithConfidenceSection;